// extracted by mini-css-extract-plugin
export default {"classTypeSelect":"CreateClassPage_classTypeSelect__HHfdk"};